module.exports = __webpack_public_path__ + "static/nicole-honeywill-1432804-unsplash-wide-f471f544fa5949d153337ce008cd1021.jpg";